import { createSelector } from 'reselect';

const selectAgentnetTypes = (state: any) => state.agentnetTypes;


export const selectAgentnetTypesCurrentItem = createSelector([selectAgentnetTypes], (agentnetTypes) => agentnetTypes.current);

export const selectAgentnetTypesListItems = createSelector([selectAgentnetTypes], (agentnetTypes) => agentnetTypes.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectAgentnetTypesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectAgentnetTypesQueryItems = createSelector([selectAgentnetTypes], (agentnetTypes) => agentnetTypes.query);

export const selectAgentnetTypesCreatedItem = createSelector([selectAgentnetTypes], (agentnetTypes) => agentnetTypes.create);

export const selectAgentnetTypesUpdatedItem = createSelector([selectAgentnetTypes], (agentnetTypes) => agentnetTypes.update);

export const selectAgentnetTypesReadItem = createSelector([selectAgentnetTypes], (agentnetTypes) => agentnetTypes.read);

export const selectAgentnetTypesDeletedItem = createSelector([selectAgentnetTypes], (agentnetTypes) => agentnetTypes.delete);

export const selectAgentnetTypesSearchedItems = createSelector([selectAgentnetTypes], (agentnetTypes) => agentnetTypes.search);

export const selectAgentnetTypesItemsCount = createSelector([selectAgentnetTypes], (agentnetTypes) => agentnetTypes.count);

export const selectAgentnetTypesItemsFilter = createSelector([selectAgentnetTypes], (agentnetTypes) => agentnetTypes.filter);